<app-nav></app-nav>
<div class="container">
    <lib-user-progress
            [slides]="slides"
            [photoURL]="photoURL"
            [currentStepIndex]="currentStepIndex"
            [currentStepProgress]="currentStepProgress"
    ></lib-user-progress>
</div>
